export default {
  addOns: 'ส่วนเสริม',
  availability: 'จำนวนที่ว่าง',
  availabilityDaySelector: 'ตัวเลือกวันที่ว่าง',
  unavailable: 'ไม่ว่าง',
  person: 'คน',
  people: 'คน',
  reserveNow: 'จองเลย',
  selectTime: 'เลือกเวลา',
  select: 'เลือก',
  reserve: 'จอง',
  time: 'เวลา',
  tier: 'ระดับ',
  questions: 'คำถาม',
  addToCart: 'เพิ่มลงตะกร้า',
  checkout: 'ชำระเงิน',
  total: 'รวม',
  whatsIncluded: 'สิ่งที่รวมอยู่',
  showMore: 'แสดงเพิ่มเติม',
  showLess: 'แสดงน้อยลง',
  session: 'รอบ',
  viewDetails: 'ดูรายละเอียด',
  findAvailability: 'ค้นหารอบที่ว่าง',
  loading: 'กำลังโหลด',
  capacity: 'ความจุ',
  noAvailableSessionsOnThisDate: 'ไม่มีรอบว่างในวันนี้',
  noGroupAvailableOnThisDateAndTime:
    'ไม่มี {{groupTitle}} ว่างในวันที่และเวลานี้',
  noCollectionFound: 'ไม่พบคอลเลกชัน!',
  noResourceGroupFound: 'ไม่พบกลุ่มทรัพยากร!',
  noData: 'ไม่มีข้อมูล!',
  continue: 'ดำเนินการต่อ',
  night: 'คืน',
  nights: 'คืน',
  noAvailableSessionsForSelectedDates:
    'บางวันที่คุณเลือกไม่มีรอบว่าง กรุณาเลือกวันอื่น',
  from: 'เริ่มต้น',
  dateRangeSelector: 'ตัวเลือกช่วงวันที่',
  priceTierRadioGroup: 'ตัวเลือกระดับราคา',
  startTime: 'เวลาเริ่ม',
  duration: 'ระยะเวลา',
  lengthOfStay: 'ระยะเวลาเข้าพัก',
  startDate: 'วันที่เริ่มต้น',
  endDate: 'วันที่สิ้นสุด',
  selectDates: 'เลือกวันที่',
  more: 'เพิ่มเติม',
  selectStartTime: 'เลือกเวลาเริ่ม',
  endTime: 'เวลาสิ้นสุด',
  selectEndTime: 'เลือกเวลาสิ้นสุด',
  morning: 'ช่วงเช้า',
  afternoon: 'ช่วงบ่าย',
  save: 'บันทึก',
  selectDuration: 'เลือกระยะเวลา',
  forLength: 'สำหรับ {{length}}',
  moreDates: 'อีก {{count}}',
  addDate: 'เพิ่มวันที่',
  start: 'เริ่มต้น',
  end: 'สิ้นสุด',
  pickupFrom: 'รับของตั้งแต่',
  returnBy: 'คืนภายใน',
  day: 'วัน',
  days: 'วัน',
  hour: 'ชั่วโมง',
  hours: 'ชั่วโมง',
};
